import {
  DraftTopExpression,
  TopExpression,
  Variable,
} from 'bones/utils/queryBuilder/types';

export const getUsedVariables = (
  topExpression: TopExpression | DraftTopExpression
) => {
  const result: Record<string, string[]> = {};
  const assignVariable = ({ id, iri }: Variable) => {
    if (!result[iri]) {
      result[iri] = [];
    }
    if (!result[iri].includes(id)) {
      result[iri].push(id);
    }
  };
  topExpression.expressions.forEach((subExpression) =>
    subExpression.expressions.forEach((expression) => {
      expression.filters.forEach((filter) => {
        if (filter.subject) {
          assignVariable(filter.subject);
        }
        if (filter.value && typeof filter.value !== 'string') {
          assignVariable(filter.value);
        }
        if (filter.comparisonSubject) {
          assignVariable(filter.comparisonSubject);
        }
      });
    })
  );
  return result;
};
